module.exports = __webpack_public_path__ + "img/sld_inverter_green_t1_dark.68f0a363.svg";